import { Grid } from "@mui/material";
import React from "react";
import CourseHeader from "./home/header";
import CourseTable from "./home/table";

const Course = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CourseHeader />
      </Grid>
      <Grid item xs={12}>
        <CourseTable />
      </Grid>
    </Grid>
  );
};

export default Course;
